module.exports = __webpack_public_path__ + "static/media/gridia-accent.svg:Zone.7a821669.Identifier";